export default __webpack_public_path__ + "static/media/logo_gov.8677ab45.png";